const actionTypes = {
    common: {
        SHOW_500_ERROR: 'SHOW_500_ERROR',
        SHOW_PAGE_NOT_FOUND_ERROR: 'SHOW_PAGE_NOT_FOUND_ERROR',
        CLEAR_ERROR: 'CLEAR_ERROR',
    },
    auth: {
        LOGIN_REQUEST: 'USERS_LOGIN_REQUEST',
        LOGIN_SUCCESS: 'USERS_LOGIN_SUCCESS',
        LOGIN_FAILURE: 'USERS_LOGIN_FAILURE',
        CLEAR_USER: 'CLEAR_USER',
        LOGOUT_SUCCESS: 'LOGOUT_SUCCESS',
        LOGOUT_REQUEST: 'LOGOUT_REQUEST',
        SIGNUP_REQUEST: 'RESEARCHERS_SIGNUP_REQUEST',
        SIGNUP_SUCCESS: 'RESEACHERS_SIGNUP_SUCCESS',
        SIGNUP_FAILURE: 'USERS_SIGNUP_FAILURE',
        USER_SIGNUP_REQUEST: 'USER_SIGNUP_REQUEST',
        USER_SIGNUP_SUCCESS: 'USER_SIGNUP_SUCCESS',
        USER_SIGNUP_FAILURE: 'USER_SIGNUP_FAILURE'
    },
    product: {
        REQUEST: 'PRODUCT_LIST_REQUEST',
        LIST_SUCCESS: 'PRODUCT_LIST_SUCCESS',
        LIST_FAILURE: 'PRODUCT_LIST_FAILURE',
        UPDATE_ADD_PRODUCT: 'UPDATE_ADD_PRODUCT',
        DETAIL_SUCCESS: 'PRODUCT_DETAIL_SUCCESS',
        DETAIL_FAILURE: 'PRODUCT_DETIAL_FAILURE',
        CLEAR_PRODUCT_DETAIL: 'PRODUCT_DETAIL_CLEAR',
        CREATE_SUCCESS: 'PRODUCT_CREATE_SUCCESS',
        CREATE_FAILURE: 'PRODUCT_CREATE_FAILURE',
        UPDATE_SUCCESS: 'PRODUCT_UPDATE_SUCCESS',
        UPDATE_FAILURE: 'PRODUCT_UDPATE_FAILURE',
    },
    questionnaire: {
        QUESTIONNAIRE_CREATE_REQUEST: 'QUESTIONNAIRE_CREATE_REQUEST',
        QUESTIONNAIRE_CREATE_SUCCESS: 'QUESTIONNAIRE_CREATE_SUCCESS',
        QUESTIONNAIRE_CREATE_FAILURE: 'QUESTIONNAIRE_CREATE_FAILURE',
        QUESTIONNAIRE_DETAILS_REQUEST: 'QUESTIONNAIRE_DETAILS_REQUEST',
        QUESTIONNAIRE_DETAILS_SUCCESS: 'QUESTIONNAIRE_DETAILS_SUCCESS',
        QUESTIONNAIRE_DETAILS_FAILURE: ' QUESTIONNAIRE_DETAILS_FAILURE',
        CLEAR_QUESTIONNAIRE_LIST: 'CLEAR_QUESTIONNAIRE_LIST'
    },
    prototype: {
        ADD_PROTOTYPE_REQUEST: 'ADD_PROTOTYPE_REQUEST',
        ADD_PROTOTYPE_SUCCESS: 'ADD_PROTOTYPE_SUCCESS',
        ADD_PROTOTYPE_FAILURE: 'ADD_PROTOTYPE_FAILURE',
        PROTOTYPE_DETAILS_REQUEST: 'PROTOTYPE_DETAILS_REQUEST',
        PROTOTYPE_DETAILS_SUCCESS: 'PROTOTYPE_DETAILS_SUCCESS',
        PROTOTYPE_DETAILS_FAILURE: 'PROTOTYPE_DETAILS_FAILURE',
        CLEAR_PROTOTYPE_LIST: 'PROTOTYPE_LIST_CLEAR',
    },
    loader: {
        SHOW_LOADER: 'SHOW_LOADER',
        HIDE_LOADER: 'HIDE_LOADER'
    },
    questionnaireReview: {
        SUBMIT_REVIEW_FAILURE: 'SUBMIT_REVIEW_FAILURE',
        SUBMIT_REVIEW_SUCCESS: 'SUBMIT_REVIEW_SUCCESS',
        CLEAR_QUESTIONNAIR_RESPONSE_LIST: ' CLEAR_QUESTIONNAIR_RESPONSE_LIST'
    },
    prototypeReview: {
        SUBMIT_REVIEW_FAILURE: 'SUBMIT_REVIEW_FAILURE',
        SUBMIT_REVIEW_SUCCESS: 'SUBMIT_REVIEW_SUCCESS',
        CLEAR_PROTOTYPE_RESPONSE_LIST: ' CLEAR_PROTOTYPE_RESPONSE_LIST',
        CLEAR_QUESTIONNAIR_RESPONSE_LIST: ' CLEAR_PROTOTYPE_RESPONSE_LIST'
    },
    participantProduct: {
        REQUEST: 'PRODUCT_LIST_REQUEST',
        LIST_SUCCESS: 'PRODUCT_LIST_SUCCESS',
        LIST_FAILURE: 'PRODUCT_LIST_FAILURE',
        UPDATE_ADD_PRODUCT: 'UPDATE_ADD_PRODUCT',
        DETAIL_SUCCESS: 'PRODUCT_DETAIL_SUCCESS',
        DETAIL_FAILURE: 'PRODUCT_DETIAL_FAILURE',
        CLEAR_PRODUCT_DETAIL: 'PRODUCT_DETAIL_CLEAR',
    }
};

export default actionTypes;
